"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var isObj = function isObj(item) {
  return typeof item === 'object';
};
var getLastIndexToDigest = function getLastIndexToDigest(args) {
  var lastIndexToDigest = args.findIndex(function (arg) {
    return arg && isObj(arg);
  });
  if (lastIndexToDigest < 0) {
    lastIndexToDigest = args.length;
  }
  return lastIndexToDigest;
};
var _default = function _default(argumentList) {
  var getArgumentName = function getArgumentName(index) {
    return argumentList[index];
  };
  var canBeDigested = function canBeDigested(args) {
    return !isObj(args) || Object.keys(args).every(function (paramName) {
      return argumentList.includes(paramName);
    });
  };
  var splitConfig = function splitConfig(args) {
    var _reverse = _toConsumableArray(args).reverse(),
      _reverse2 = _toArray(_reverse),
      config = _reverse2[0],
      restArgs = _reverse2.slice(1);
    if (!canBeDigested(config)) {
      return {
        config: config,
        args: restArgs.reverse()
      };
    }
    return {
      config: null,
      args: args
    };
  };
  var digest = function digest() {
    for (var _len = arguments.length, gaArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      gaArgs[_key] = arguments[_key];
    }
    var _splitConfig = splitConfig(gaArgs),
      config = _splitConfig.config,
      args = _splitConfig.args;
    var lastIndexToDigest = getLastIndexToDigest(args);
    var digested = args.slice(0, lastIndexToDigest).reduce(function (acc, arg, i) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, getArgumentName(i), arg));
    }, {});
    var gaParams = args[lastIndexToDigest] ? _objectSpread(_objectSpread({}, digested), args[lastIndexToDigest]) : digested;
    return _objectSpread(_objectSpread({}, gaParams), config);

    // return [, config].filter(Boolean);
  };

  return {
    digest: digest
  };
};
exports.default = _default;
//# sourceMappingURL=argumentDigester.js.map